(function ($) {
    $(document).ready(function () {

        // Slick Track Attribute
      	$('#Slideshow-announcement-bar .slick-track').attr("aria-label", "Announcement Bar");
        $('.snowSlides .slick-track').attr("aria-label", "homepage-slider");
        $('.hero .slick-track').attr("aria-label", "hero-slide");
        $('.product__thumb-item').attr("tabindex", - 1);
        $('.product__thumb-item').removeAttr("aria-hidden");
        $('.product__photos .slick-track').attr("aria-label", "product-photos");
		$('.slick-dots li').attr('role','tab');
      	$('.slick-dots li').removeAttr("aria-hidden");
      	$('.slick-dots li').removeAttr("aria-controls");

    });
})(jQuery);